// JS for block-specific behavior only
console.log('res steps light block loaded');